import requests from '../utils/axios'


export const recordUserEnter = async (external_user_id) => {
    try {
        await requests.post('/event', { external_user_id })
    } catch (error) {
    
    }
}